import { AccountItemEnum } from '../../../../../../../../../modules/mobile/modals/profile';

export default {
  title: 'Compte',
  items: {
    [AccountItemEnum.ManageAccount]: {
      title: 'Gérer le compte',
      description: 'Gardez votre compte à jour et gérez vos paramètres.',
    },
    [AccountItemEnum.PaymentMethods]: {
      title: 'Modes de paiement',
      description: 'Ajoutez, modifiez ou sélectionnez votre mode de paiement préféré.',
    },
    [AccountItemEnum.HelpAndFAQs]: {
      title: 'Aide et FAQ',
    },
    [AccountItemEnum.Logout]: {
      title: 'Se déconnecter',
    },
    [AccountItemEnum.Language]: {
      title: 'Langue',
    },
  },
};
